import { Injectable } from '@angular/core';
import { Constants } from '../../../shared/constant';
import { BaseService } from '../../../../core/base/base.service';
import { ProjectUtils } from '../../../shared/project-utils';
import { HttpService } from '../../../../core/http.service';

@Injectable()
export class PushLiveAndRollBackService extends BaseService {

  constructor(
    protected httpService: HttpService
  ) {
    super(httpService)
  }

  getServiceURL(): string {
    return Constants.ACC_GROUP_TYPE_URL;
  }

  deleteDataWithINST_ID(institution_id: string) {
    const body = this.setParamValue('', 'institution_id', institution_id);
    return this.getDataWithURL(Constants.IN_ROLLBACK_DELETE_URL, body);
  }

  getManualRollback(body: any): any {
    return this.getDataWithURL(Constants.IN_PROCESSING_QA_MANUALROLLBACK, body);
  }

  rollBackAll(body: any): any {
    return this.getDataWithURL(Constants.IN_ROLLBACK_ALL, body);
  }

  pushLiveAll(): any {
    let body = '';
    return this.getDataWithURL(Constants.IN_PUSHLIVE_ALL, body);
  }

  pushLiveselectedmonth(month:string): any {
    let body = '';
    body += this.setParamValue(body, 'month', month);
    return this.getDataWithURL(Constants.IN_PUSHLIVE_ALL, body);
  }

  getQaMonthList(): any {
    let body = '';
    return this.getDataWithURL(Constants.IN_QAMONTHS, body);
  }

  addColumnsOptionQaMonths(dtOptions: any) {
    dtOptions['columns'] = [

      {
        'data': 'AccountsLive',
        'title': 'Total Accounts live'
      },
      {
        'data': 'AccountsQa',
        'title': 'Total Accounts QA',
      }, {
        'data': 'Month_Year',
        'title': 'Month-Year'
      },
      {
        'data': 'PushLive',
        'title': 'Push Live',
      }
    ];
  }
 
  addColumnsOptionRollback(dtOptions: any) {
    dtOptions['columns'] = [
      {
        'data': 'Account ID',
        'title': 'Account ID'
      },
      {
        'data': 'Account name',
        'title': 'Account Name'
      },
      {
        'data': 'Status',
        'title': 'Status'
      },
      {
        'data': 'undo',
        'title': 'ROLLBACK',
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/insight/processing/push-live-and-roll-back/push-live-and-roll-back.service.ts